<template>
    <!-- Withdraw Password Modal -->
    <div class="modal fade modal-style forgot-password-modal" ref="withdraw" id="withdrawalPassword" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" data-bs-backdrop="static" data-bs-keyboard="false">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $t('forgot-withdraw-password','Forgot Withdraw Password') }}</h5>
                    <button type="button"  @click="$helper.closeModal('withdrawalPassword');resetWithdrawForm(),oldPasswordFieldType = 'password',newPasswordFieldType='password'" class="btn-close">
                        <i class="fa-solid fa-xmark"></i>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="withdraw-password-update withdraw_container">
                        <div class="otp-msg-show">
                            <label for="">{{ $t('otp-sent-to', 'OTP sent to') }}. <strong>****** {{ $auth.user.phone?.slice(-4) }}</strong></label>
                        </div>
                        <div class="withdraw-instruction">
                            <h4>{{ $t('withdraw-instruction', 'Withdraw Instruction') }}</h4>
                            <ul>
                                <li>{{ $t('withdraw-password-eight-twenty', 'Withdraw Password Must be of minimum 8 characters and maximum 20 characters required') }}</li>
                                <li>{{ $t('withdraw-password-small-capital', 'Withdraw Password Must have atleast 1 small and 1 capital alphabet') }}</li>
                                <li>{{ $t('withdraw-password-digit-special-char', 'Withdraw Password Must have atleast 1 Digit and 1 Special character') }}</li>
                                <li>{{ $t('please-take-note-your-withdraw-password', 'Please take a note of your Withdraw Password') }}</li>
                            </ul>
                        </div>

                        <div class="acc-login-form-sec">
                            <label for="">{{ $t('enter-withdrawal-otp', 'Enter Withdrawal OTP') }} <small style="color: red;">*</small></label>
                            <div class="withdraw-otp-row">
                                <input type="tel" v-model="withdraw.otp"  maxlength="6" :placeholder="$t('enter-otp','Enter OTP')" class="form-control"
                                    :class="isOtpApiCalled && init.otp && checkValidation?.otp?.length > 0 ? 'border border-1 border-danger': ''" 
                                    @input="withdraw.otp = $helper.sanitizeNumber(withdraw.otp, 999999); validate() " />
                                    <div class="withdraw_otp_sec">
                                        <span class="resend-otp resend-timer" v-if="minutes > 0 || seconds > 0">{{ minutes }}:{{ seconds }}</span> 
                                        <button v-if="isResentOtpBtnVisiable" @click="resendOtp()" class="btn link-btn resend-otp">{{ $t('resend-otp', 'RESEND OTP') }}</button>
                                    </div>
                                </div>
                            <section v-if="isOtpApiCalled && init.otp && checkValidation?.otp?.length > 0">
                                <section v-for="(err, index) in checkValidation?.otp" :key="index">
                                    <p class="wallet-error">&#x2022; {{ $t(err.lang, err.error) }}</p>
                                </section>
                            </section>
                        </div>

                        <div class="acc-login-form-sec">
                            <label for="">{{ $t('withDraw-password', 'Withdraw Password') }} <small style="color: red;">*</small></label>
                            <div class="password-field-rel">
                                <input v-model="withdraw.password" :type="oldPasswordFieldType" :placeholder="$t('enter-withdraw-password', 'Enter Withdraw Password')" class="form-control"
                                    @input="withdraw.password = $helper.sanitizeDetails('withdrawPassword', withdraw.password, 20); validate()" 
                                    :class="isOtpApiCalled && init.password && checkValidation?.password?.length > 0 ? 'border border-1 border-danger' : ''" />
                                <div class="score-hide-show" @click="togglePasswordVisibility('oldPassword')">
                                    <i class="fa-solid" :class="oldPasswordFieldType === 'password' ? 'fa-eye-slash' : 'fa-eye'"></i>
                                </div>
                            </div>
                            <section v-if="isOtpApiCalled && init.password && checkValidation?.password?.length > 0">
                                <section v-for="(err, index) in checkValidation?.password" :key="index">
                                    <p class="wallet-error"><small> &#x2022; {{ $t(err.lang, err.error) }}</small></p>
                                </section>
                            </section>
                            <section v-if="isOtpApiCalled && init.password && checkValidation?.withdrawPassword?.length > 0">
                                <section v-for="(err, index) in checkValidation?.withdrawPassword" :key="index">
                                    <p class="wallet-error"><small> &#x2022; {{ $t(err.lang, err.error) }}</small></p>
                                </section>
                            </section>
                        </div>

                        <div class="acc-login-form-sec">
                            <label for="">{{ $t('confirm-withDraw-password', 'Confirm Withdraw Password') }} <small style="color: red;">*</small></label>
                            <div class="password-field-rel">
                                <input v-model="withdraw.c_password" :type="newPasswordFieldType" :placeholder="$t('enter-confirm-withdraw-password', 'Enter Confirm Withdraw Password')" class="form-control"
                                    @input="withdraw.c_password = $helper.sanitizeDetails('withdrawPassword', withdraw.c_password, 20); validate()" 
                                    :class="isOtpApiCalled && init.confirmPassword && checkValidation?.confirmPassword?.length > 0 ? 'border border-1 border-danger' : ''" />
                                <div class="score-hide-show" @click="togglePasswordVisibility('newPassword')">
                                    <i class="fa-solid" :class="newPasswordFieldType === 'password' ? 'fa-eye-slash' : 'fa-eye'"></i>
                                </div>
                            </div>
                            <section v-if="isOtpApiCalled && init.c_password && checkValidation?.confirmPassword?.length > 0">
                                <section v-for="(err, index) in checkValidation?.confirmPassword" :key="index">
                                    <p class="wallet-error"><small>&#x2022; {{ $t(err.lang, err.error) }}</small></p>
                                </section>
                            </section>
                        </div>

                        <div class="forgot-submit-btn">
                            <button @click="validateOtp()" class="btn thm-but">{{ $t('submit', 'Submit') }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import validate from '@/modules/authorization/services/authValidation';
import {resetWithdrawalPassword, openWithdrawPasswordModal, startWithdrawTimer} from "../services/withdrawAccountDetails"
export default{
    name:'WithdrawalPasswordSetReset',
    emits:['openWithdrawPasswordModal'],
    props:{
        is_withdrawal_password_set: Boolean,
        isWithdrawalPasswordSet: Function
    },
    data(){
        return{
            withdraw : {
                phone : '',
                otp : '',
                password : '',
                c_password : '',
            },
            isResentOtpBtnVisiable : false,
            startTime: null,
            endTime: null,
            timeLeft: 0,
            timer: null,
            validationErrors : null,
            init:{
                otp:false,
                c_password:false,
                password:false
            },
            isOtpApiCalled:false,
            oldPasswordFieldType : 'password',
            newPasswordFieldType: 'password',
        }
    },
    computed:{
        minutes() {
            return Math.floor(this.timeLeft / 60).toString().padStart(2, '0');
        },
        seconds() {
            return (this.timeLeft % 60).toString().padStart(2, '0');
        },
        checkValidation() {
			return this.validationErrors;
		}
    },
    methods:{
        togglePasswordVisibility(fieldName) {
            if(fieldName == 'oldPassword'){
                this.oldPasswordFieldType = this.oldPasswordFieldType === 'password' ? 'text' : 'password';
            } else{
                this.newPasswordFieldType = this.newPasswordFieldType === 'password' ? 'text' : 'password';
            }
        },
        toggleInit(bool){
            this.init={
                otp:bool,
            }
        },
        togglePassInit(bool){
            this.init={
                c_password:bool,
                password:bool
            }
        },
        validate(){
            this.validationErrors = validate.areFieldsValid(
                'withdraw-password',
				this.withdraw.otp, 
				this.withdraw.password,
				this.withdraw.c_password,
            );
            return this.validationErrors;                                                                                                    
        },
        async resetWithdrawForm(){
            this.withdraw ={
                phone: '',
                otp: '',
                password: '',
                c_password: ''
            },
            this.isOtpApiCalled = false;
            this.validationErrors = null;
            this.toggleInit(false)
        },
        async resendOtp(){
            // try {
            //     this.$apiCall('get', 'SENT_OTP_TO_MOBILE', null, 'wallet', null).then(res => {
            //         if (res.status == 200) {
            //             let data    = res.data.data;
            //             let status  = data.status;
            //             if(status == 1){
            //                 this.$successToast(res.data.message);
            //                 this.resetTimer();
            //             }else{
            //                 this.$errorToast(res.data.message);
            //             }
            //         }
            //     });
            // } catch (error) {
            //     this.$errorToast(error);
            // }

            // this.loading = true
            try {
                let response = await openWithdrawPasswordModal()
                if(!response?.error){
                    this.resetTimer()
                }
            } catch (error) {
                this.$errorToast(error);
            }
        },
        startTimer() {
            this.startTime = new Date();
            this.endTime = new Date(this.startTime.getTime() + 5 * 60 * 1000);
            this.timeLeft = 5 * 60;
            this.isResentOtpBtnVisiable = false;

            this.timer = setInterval(() => {
                const currentTime = new Date();
                this.timeLeft = Math.floor((this.endTime - currentTime) / 1000);

                if (this.timeLeft <= 0) {
                    clearInterval(this.timer);
                    this.stopTimer();
                    this.timeLeft = 0;
                    this.isResentOtpBtnVisiable = true;
                }
            }, 1000);
        },
        stopTimer() {
            this.isResentOtpBtnVisiable = false;
            clearInterval(this.timer);
        },
        resetTimer() {
            this.isResentOtpBtnVisiable = false;
            clearInterval(this.timer);
            this.startTime = null;
            this.endTime = null;
            this.timeLeft = 5 * 60;
            this.startTimer();
        },
        async validateOtp() {
            this.toggleInit(true);
            if(this.withdraw.otp && this.withdraw.otp?.length == 6){
                this.togglePassInit(true);
            }
            if (Object.keys(this.validate())?.filter(key => !['newPassword', 'newUserId'].includes(key))?.length !== 0) return;
            const resetResponse = await this.resetWithdrawalPassword()

            if (resetResponse.error) {
                this.$errorToast(resetResponse?.error);
                if(resetResponse?.error?.[0]?.includes('OTP Expired')){
                    this.isResentOtpBtnVisiable = true;
                    clearInterval(this.timer);
                    this.timeLeft = 0;
                }
                return;
            }
            else {
                await this.resetWithdrawForm();
                this.$helper.closeModal('withdrawalPassword');
                this.resetTimer();
                // this.$successToast(resetResponse?.message);
            }
        },
        async resetWithdrawalPassword(){
            if (!this.withdraw.password || this.withdraw.password == null) {
                this.$errorToast("New WithDraw Password Required!");
                return; 
            }
            if (this.withdraw.password != this.withdraw.c_password) {
                this.$errorToast("Confirm WithDraw Password Does Not Match With New WithDraw Password");
                return;
            }
            let data = {
                otp: this.withdraw.otp,
                password: this.withdraw.password,
            }
            console.log(data)

            let response = await resetWithdrawalPassword(data)
            if(response?.error) return {error : response.error}
            else return true
        },
        otpHasBeenCalled(){
            this.isOtpApiCalled = true;
        },
        assignWithdrawPhoneNumber(number){
            this.withdraw.phone = number
        }
    }
}
</script>

<style scoped>
.border-danger {
    border: 2px solid #ff0000 !important;
}
.text-danger .error-msg{
  color: #ff0000 !important;
}
.password-field-rel {
    position: relative;
}
.score-hide-show {
    position: absolute;
    top: 8px;
    right: 13px;
    color: var(--text-highlight);
}
.score-hide-show img{
    max-width: 18px;
}
</style>